module.exports = __webpack_public_path__ + "createstatic/media/categoryIcn.b8491e58.svg";